export const appSettingsCustomEventUsage = "/app_settings/custom_event_usage";
